import React from 'react';
import { useConnect } from '@lore/query-connect';
import { EnvelopeIcon, CalendarIcon } from '@heroicons/react/24/outline';
import avatar from '../../../assets/images/avatar.svg';
import Card from '../../components/Card';

export default function TeamContact(props) {
  const { supportQuestion } = props;

  const [firstName, lastName] = supportQuestion.data.staffName.split(' ');

  return (
    <Card>
      {/*<div className="p-6 space-y-6">*/}
      <div className="flex flex-col sm:flex-row px-4 py-3 space-x-0 sm:space-x-4 space-y-2 sm:space-y-0">
        <div className="flex h-14 w-14">
          <img
            className="rounded-full object-center object-cover aspect-1"
            src={supportQuestion.data.staffAvatarUrl || avatar}
            alt=""
          />
        </div>
        <div className="flex-1 space-y-2">
          <div>
            <div className="text-lg font-semibold text-cs-gray-900">
              {supportQuestion.data.staffName}
            </div>
            <div className="text-sm text-cs-gray-500">
              {supportQuestion.data.staffDescription}
            </div>
          </div>
          <div className="flex flex-col md:flex-row space-y-1 space-x-0 md:space-y-0 md:space-x-4">
            {supportQuestion.data.staffEmail && (
              <div className="flex items-center space-x-1 text-cs-blue-500">
                <EnvelopeIcon className="h-5 w-5"/>
                <div className="flex-1">
                  <a className="block text-sm text-cs-blue-500" href={`mailto:${supportQuestion.data.staffEmail}`}>
                    Chat with {firstName}
                  </a>
                </div>
              </div>
            )}
            {supportQuestion.data.staffSchedulingUrl && (
              <div className="flex items-center space-x-1 text-cs-blue-500">
                <CalendarIcon className="h-5 w-5"/>
                <div className="flex-1">
                  <a className="block text-sm text-cs-blue-500" target="_blank" href={supportQuestion.data.staffSchedulingUrl}>
                    Schedule time with {firstName}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
